import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateFamily = () => {
  const history = useHistory();
  let { id } = useParams();

  const familyTypes = ["Joint Family", "Nuclear Family"];
  const familyStatus = [
    "Rich",
    "Very Rich",
    "Upper Middle class",
    "Middle class",
    "Lower Middle class",
    "Affluent",
  ];

  const [data, setData] = useState({
    userId: id,
    fatherStatus: "",
    motherStatus: "",
    elderBrothers: 0,
    elderBrothersMarried: 0,
    youngerBrothers: 0,
    youngerBrothersMarried: 0,
    elderSisters: 0,
    elderSistersMarried: 0,
    youngerSisters: 0,
    youngerSistersMarried: 0,
    familyType: "",
    familyStatus: "",
    member1: "",
    member1Mobile: "",
    member2: "",
    member2Mobile: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .post("/admin/userProfile/familyUpdate/", {
        ...data,
        userId: Number(id),
      })
      .then(() => {
        Swal.fire(
          "Updated!",
          "Family details updated successfully.",
          "success"
        );
        history.goBack();
      });
  };
  useEffect(() => {
    if (!id) return;
    api.get(`/admin/userProfile/profileView/?userId=${id}`).then((res) => {
      if (res.data.data !== "Data not found") {
        setData(res.data.data.userFamily);
      }
    });
  }, [id]);

  return (
    <div className="content">
      <Row>
        <Col xs={12} md={12}>
          <div className="page-title">
            <div className="float-left">
              <h1 className="title">Update Family Details</h1>
            </div>
          </div>

          <div className="col-12">
            <section className="box">
              <div className="content-body">
                <Form onSubmit={handleSubmit} className="form">
                  <Box sx={{ minWidth: 120 }}>
                    {/* Father Status */}
                    <FormGroup>
                      <Label for="fatherStatus">Father Status</Label>
                      <Input
                        name="fatherStatus"
                        value={data.fatherStatus}
                        type="text"
                        id="fatherStatus"
                        placeholder="e.g. Businessman / Retired / Passed Away"
                        onChange={handleChange}
                      />
                    </FormGroup>

                    {/* Mother Status */}
                    <FormGroup>
                      <Label for="motherStatus">Mother Status</Label>
                      <Input
                        name="motherStatus"
                        value={data.motherStatus}
                        type="text"
                        id="motherStatus"
                        placeholder="e.g. Homemaker / Retired / Passed Away"
                        onChange={handleChange}
                      />
                    </FormGroup>

                    {/* Elder Brothers */}
                    <FormGroup>
                      <Label for="elderBrothers">Elder Brothers</Label>
                      <Input
                        name="elderBrothers"
                        value={data.elderBrothers}
                        type="number"
                        min="0"
                        id="elderBrothers"
                        onChange={handleChange}
                      />
                    </FormGroup>
                    {data.elderBrothers > 0 && (
                      <FormGroup>
                        <Label for="elderBrothersMarried">
                          Elder Brothers Married
                        </Label>
                        <Input
                          name="elderBrothersMarried"
                          value={data.elderBrothersMarried}
                          type="number"
                          min="0"
                          id="elderBrothersMarried"
                          onChange={handleChange}
                        />
                      </FormGroup>
                    )}

                    {/* Younger Brothers */}
                    <FormGroup>
                      <Label for="youngerBrothers">Younger Brothers</Label>
                      <Input
                        name="youngerBrothers"
                        value={data.youngerBrothers}
                        type="number"
                        min="0"
                        id="youngerBrothers"
                        onChange={handleChange}
                      />
                    </FormGroup>
                    {data.youngerBrothers > 0 && (
                      <FormGroup>
                        <Label for="youngerBrothersMarried">
                          Younger Brothers Married
                        </Label>
                        <Input
                          name="youngerBrothersMarried"
                          value={data.youngerBrothersMarried}
                          type="number"
                          min="0"
                          id="youngerBrothersMarried"
                          onChange={handleChange}
                        />
                      </FormGroup>
                    )}

                    {/* Elder Sisters */}
                    <FormGroup>
                      <Label for="elderSisters">Elder Sisters</Label>
                      <Input
                        name="elderSisters"
                        value={data.elderSisters}
                        type="number"
                        min="0"
                        id="elderSisters"
                        onChange={handleChange}
                      />
                    </FormGroup>
                    {data.elderSisters > 0 && (
                      <FormGroup>
                        <Label for="elderSistersMarried">
                          Elder Sisters Married
                        </Label>
                        <Input
                          name="elderSistersMarried"
                          value={data.elderSistersMarried}
                          type="number"
                          min="0"
                          id="elderSistersMarried"
                          onChange={handleChange}
                        />
                      </FormGroup>
                    )}

                    {/* Younger Sisters */}
                    <FormGroup>
                      <Label for="youngerSisters">Younger Sisters</Label>
                      <Input
                        name="youngerSisters"
                        value={data.youngerSisters}
                        type="number"
                        min="0"
                        id="youngerSisters"
                        onChange={handleChange}
                      />
                    </FormGroup>
                    {data.youngerSisters > 0 && (
                      <FormGroup>
                        <Label for="youngerSistersMarried">
                          Younger Sisters Married
                        </Label>
                        <Input
                          name="youngerSistersMarried"
                          value={data.youngerSistersMarried}
                          type="number"
                          min="0"
                          id="youngerSistersMarried"
                          onChange={handleChange}
                        />
                      </FormGroup>
                    )}

                    {/* Family Type */}
                    <FormGroup>
                      <Label for="familyType">Family Type</Label>
                      <Input
                        name="familyType"
                        value={data.familyType}
                        type="select"
                        id="familyType"
                        onChange={handleChange}
                      >
                        <option value="">Select Family Type</option>
                        {familyTypes.map((x) => (
                          <option key={x} value={x}>
                            {x}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    {/* Family Status */}
                    <FormGroup>
                      <Label for="familyStatus">Family Status</Label>
                      <Input
                        name="familyStatus"
                        value={data.familyStatus}
                        type="select"
                        id="familyStatus"
                        onChange={handleChange}
                      >
                        <option value="">Select Family Status</option>
                        {familyStatus.map((x) => (
                          <option key={x} value={x}>
                            {x}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    {/* Member 1 */}
                    <FormGroup>
                      <Label for="member1">Member 1</Label>
                      <Input
                        name="member1"
                        value={data.member1}
                        type="text"
                        id="member1"
                        placeholder="Relation (e.g. Sister)"
                        onChange={handleChange}
                      />
                      <Input
                        name="member1Mobile"
                        value={data.member1Mobile}
                        type="text"
                        id="member1Mobile"
                        placeholder="Mobile number"
                        onChange={handleChange}
                        style={{ marginTop: "5px" }}
                      />
                    </FormGroup>

                    {/* Member 2 */}
                    <FormGroup>
                      <Label for="member2">Member 2</Label>
                      <Input
                        name="member2"
                        value={data.member2}
                        type="text"
                        id="member2"
                        placeholder="Relation (e.g. Brother)"
                        onChange={handleChange}
                      />
                      <Input
                        name="member2Mobile"
                        value={data.member2Mobile}
                        type="text"
                        id="member2Mobile"
                        placeholder="Mobile number"
                        onChange={handleChange}
                        style={{ marginTop: "5px" }}
                      />
                    </FormGroup>

                    <Button style={{ background: "black" }}>Submit</Button>
                  </Box>
                </Form>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UpdateFamily;
